import React, {useEffect} from 'react'
import gamepad from '../assets/gamer-preview.png'
import steam from '../assets/steam.png'
import ampersand from '../assets/ampersand.png'
import AOS from 'aos';
import 'aos/dist/aos.css';
require('@lottiefiles/lottie-player');


const Controls = () => {

  useEffect(() => {
    AOS.init();
  }, [])

  return (
    <section className='controls'>
    <article className='controls-grid'>
        <div className='controls-image order-last sm:order-last md:order-last lg:order-first'>
            <img src={gamepad} alt='' className='w-[100vw]'/>
        </div>
        <div className='controls-text h-[70%] md:h-[50%] lg:h-[30%] md:top-[50px] flex-col sm:flex-row justify-evenly lg:justify-around'>
            <h1 data-aos="fade-up" className='font-face-tk controls-title relative pl-[40px] ml-[50px] sm:ml-0 text-left sm:text-left text-3xl sm:text-xl md:text-3xl lg:text-5xl' style={{ textTransform: 'uppercase', marginBottom: '10px', fontWeight: 'bold', color: '#F68C1F'}}>
              <span className='relative inline-flex' >MOUSE <img alt='' src={ampersand} className='absolute w-[30px] lg:w-[36px] top-0 self-center right-[-40px]'/></span><br></br>
              <span className='inline-flex items-center '>
              <lottie-player
              autoplay
              loop
              mode='normal'
              class='self-center floating'
              src='https://assets10.lottiefiles.com/packages/lf20_tzwm7py3.json'
              style={{width: '200px', height: '150px', position: 'absolute', left: '-120px'}}></lottie-player>KEYBOARD</span><br></br>
              <span>GAMING</span>
            </h1>
            <p data-aos="fade-up" className='controls-paragraph text-left w-[17rem] h-24 rounded-md cursor-pointer select-none lg:text-right text-bs md:text-lg lg:text-xl' style={{color: 'ffff00', marginBottom: '30px', backgroundColor:'#0C0F51', boxShadow: '5px 5px 2px #d67515'}}> 
            <a href='https://t.co/3DSNY1jwmt' target='_blank' rel='noreferrer noopener' className='w-full h-full' style={{display:'block'}}>
              <button className='btn flex w-full h-full items-center relative' style={{}}>
                <h1 className='font-face-tk indent-24 relative text-xl font-black text-right'>AVAILABLE ON <br></br>STEAM FOR FREE<span className='inline-flex items-center'>
                <lottie-player
                  autoplay
                  loop
                  mode='normal'
                  class='self-center w-[50px] md:w-[100px] left-[245px] top-[35px] sm:left-[220px]'
                  src='https://assets3.lottiefiles.com/packages/lf20_OwH42nvufQ.json'
                  style={{ height: '70px', position: 'absolute'}}
            ></lottie-player>
                </span></h1>
                  <img src={steam} alt='' className='w-16 h-16 absolute'/>
              </button>
            </a>
            </p>
        </div>
    </article>
</section>
  )
}

export default Controls

